import { STATIC_BASE_URL } from '../constants/enum';
/**
 * Returns the URL of the icon hosted on our static environment.
 */
export const getIconUrl = (variant, type = 'ui') => {
    return `${STATIC_BASE_URL}/poncho/icon/${type}/${variant}.svg`;
};
//# sourceMappingURL=get-icon-url.js.map